// extracted by mini-css-extract-plugin
export default {"menuBlock":"KI-z","title":"LI-z","nav":"MI-z","flexCell":"NI-z","facetLink":"OI-z"};